import { render, staticRenderFns } from "./RequirementAddEdit.vue?vue&type=template&id=3477414f"
import script from "./RequirementAddEdit.vue?vue&type=script&lang=js"
export * from "./RequirementAddEdit.vue?vue&type=script&lang=js"
import style0 from "./RequirementAddEdit.vue?vue&type=style&index=0&id=3477414f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports